import {useMutation} from '@apollo/client';
import String from '../utils/string';
import config from '../config/config';
import {toastNotification} from '../components/toastify';
import {GERAR_TOKEN_ANUNCIANTE, GERAR_TOKEN_COMERCIAL} from '../graphql/mutation';

const usePainelService = () => {
  const [accessTokenAnuncianteByAdmin] = useMutation(GERAR_TOKEN_ANUNCIANTE);
  const [accessTokenComercialByAdmin] = useMutation(GERAR_TOKEN_COMERCIAL);

  const acessarPainelAnunciante = (id, setLoading) => {
    accessTokenAnuncianteByAdmin({
      variables: {
        id
      },
    })
      .then(({data}) => {
        const authData = data.accessTokenAnuncianteByAdmin;
        const authDataBuffer = Object.keys(authData).reduce(
          (actual, current) => {
            const keySnakeCase = String.transformCamelToSnakeCase(current);
            return {...actual, [keySnakeCase]: authData[current]};
          },
          {},
        );

        window.open(
          `${config.URL_PAINEL_ANUNCIANTE}?auth-data=${btoa(
            JSON.stringify(authDataBuffer),
          )}`,
        );
      })
      .catch((error) => toastNotification({message: error.message, type: 'error'}))
      .finally(() => setLoading && setLoading(true));
  };

  const acessarPainelComercial = (id, setLoading) => {
    accessTokenComercialByAdmin({
      variables: {
        id
      },
    })
      .then(({data}) => {
        const authData = data.accessTokenComercialByAdmin;
        const authDataBuffer = Object.keys(authData).reduce(
          (actual, current) => {
            const keySnakeCase = String.transformCamelToSnakeCase(current);
            return {...actual, [keySnakeCase]: authData[current]};
          },
          {},
        );

        window.open(
          `${config.URL_PAINEL_COMERCIAL}?auth-data=${btoa(
            JSON.stringify(authDataBuffer),
          )}`,
        );
      })
      .catch((error) => toastNotification({message: error.message, type: 'error'}))
      .finally(() => setLoading && setLoading(false));
  };

  return {acessarPainelAnunciante, acessarPainelComercial};
};

export default usePainelService;